// extracted by mini-css-extract-plugin
module.exports = {"icon":"pipeline_icon__n6ncC"};